import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgDone = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M7.997 15q1.436 0 2.702-.549a7.156 7.156 0 0 0 3.752-3.747A6.7 6.7 0 0 0 15 8q0-1.437-.549-2.704a7.1 7.1 0 0 0-1.517-2.23A7.2 7.2 0 0 0 10.7 1.55 6.7 6.7 0 0 0 7.99 1q-1.434 0-2.702.549A7.17 7.17 0 0 0 1.55 5.296 6.7 6.7 0 0 0 1 8q0 1.437.549 2.704.548 1.267 1.51 2.236a7.1 7.1 0 0 0 2.235 1.511A6.7 6.7 0 0 0 7.997 15m-.752-3.66a.75.75 0 0 1-.352-.08 1 1 0 0 1-.305-.265l-1.66-2.02a1 1 0 0 1-.135-.236.7.7 0 0 1-.047-.251q0-.258.176-.44a.6.6 0 0 1 .44-.19q.162 0 .291.067a.9.9 0 0 1 .264.238l1.3 1.653 2.805-4.486q.216-.352.548-.352.251 0 .447.162a.52.52 0 0 1 .204.427.6.6 0 0 1-.055.244 2 2 0 0 1-.122.23l-3.17 4.947a.8.8 0 0 1-.284.265.7.7 0 0 1-.345.088"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDone);
export default ForwardRef;
